<div #logo class="inline-block opacity-0" tabindex="0" (click)="restartNavigation()" (keypress.enter)="restartNavigation()">
   
    <!-- LOGO -->
    <picture>
        <source [srcset]="logoSrc" type="image/png">
        <img  class="h-10 grayscale transition-all duration-500 ease-in-out "
            [class]="!hasViewId ? 'hover:grayscale-0 cursor-pointer' : ''"
            alt="Logo" 
            [src]="logoSrc" 
            [attr.aria-label]="logoTitle() + ' Logo'"
        >
    </picture>
</div>